import { render, staticRenderFns } from "./InvoiceIndex.vue?vue&type=template&id=870da5fc&"
import script from "./InvoiceIndex.vue?vue&type=script&lang=js&"
export * from "./InvoiceIndex.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceIndex.vue?vue&type=style&index=0&id=870da5fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports